import gsap from "gsap";
import {
  ScrollTrigger
} from "gsap/all";
import LocomotiveScroll from 'locomotive-scroll';
import navbar from "./js/navbar";

gsap.registerPlugin(ScrollTrigger)
let portrait = window.matchMedia("(orientation: portrait)");

if (window.innerWidth > 768) {
  const locomotiveScroll = new LocomotiveScroll();
}

videoPlayer()

window.addEventListener('slideLeft', (e) => {
  const {
    target,
    progress
  } = e.detail;
  gsap.to(target, {
    x: progress * 150,
    ease: 'power2.out'
  })
});
window.addEventListener('slideRight', (e) => {
  const {
    target,
    progress
  } = e.detail;
  gsap.to(target, {
    x: progress * -150,
    ease: 'power2.out'
  })
});

function LazyLoadImage() {
  let fullRes = "1200/600";
  ScrollTrigger.config({
    limitCallbacks: true
  });

  gsap.utils.toArray(".lazy").forEach(image => {

    function loadImage() {
      gsap.fromTo(image, {
        opacity: 0,
        scale: 1.2,
      }, {
        opacity: 1,
        scale: 1,
        duration: 2,
        ease: 'power4.out',
        onStart: () => {
          image.src = image.dataset.src
        }
      })
    }

    ScrollTrigger.create({
      trigger: image,
      start: "-10% bottom",
      once: true,
      onEnter: loadImage,
      onEnterBack: loadImage
    });
  });
}

portrait.addEventListener("change", function (e) {
  if (e.matches) {
    // Portrait mode
    window.location.reload()
  } else {
    // Landscape
    window.location.reload()
  }
})

function videoPlayer() {
  const videos = document.querySelectorAll('#video')

  videos.forEach(video => {
    const btn = document.createElement('button')
    btn.innerHTML = ' <i class="fa-regular fa-circle-pause"></i> Pause'
    btn.className = 'absolute right-0 hidden mx-auto pointer-events-auto lg:block -bottom-2 lg:bottom-4 lg:right-8 text-stone-600 hover:text-black btn-play'
    video.insertAdjacentElement('afterend', btn)

    btn.addEventListener('click', () => {
      if (video.paused == true) {
        // Play the video
        video.play();
        btn.innerHTML = '<i class="fa-regular fa-circle-pause"></i> Pause'
      } else {
        // Pause the video
        video.pause();
        btn.innerHTML = '<i class="fa-regular fa-circle-play"></i> Play'

      }
    })
  })
}
